module.exports = __webpack_public_path__ + "static/media/solutions-grid-4.e3ca736f.png";